import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface BackButtonConfig {
  show: boolean;
  url?: string;
  action?: () => void;
  text?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BackButtonService {
  private backButtonConfig$ = new BehaviorSubject<BackButtonConfig>({
    show: false,
  });

  constructor(private router: Router) {}

  public getBackButtonConfig() {
    return this.backButtonConfig$.asObservable();
  }

  public showBackButton(config: BackButtonConfig) {
    this.backButtonConfig$.next(config);
  }

  public hideBackButton() {
    this.backButtonConfig$.next({ show: false });
  }

  public goBack() {
    const currentConfig = this.backButtonConfig$.value;

    if (currentConfig.action) {
      currentConfig.action();
    } else if (currentConfig.url) {
      this.router.navigateByUrl(currentConfig.url);
    } else {
      // Default back behavior
      this.router.navigate(['/home']);
    }
  }

  public getCurrentConfig(): BackButtonConfig {
    return this.backButtonConfig$.value;
  }
}
